import {getBaseUrl, getDefaultAPIKey} from '@pages/Root/services/api/api-utils.ts';
import { IFetcher, createMomentFetcher } from '@moment/net/common/fetcher.ts';


export const DEFAULT_ASPECT = 'all';
export const DEFAULT_CKEY = getDefaultAPIKey();
export const API_URL = getBaseUrl();

export const RECIRC_URL = 'wp/v1/recirc';
export const PERSONALIZATION_URL = 'wp/v1/personalization';
export const DAILY_URL = 'wp/v1/daily';
export const PUBLISHER_URL = 'wp/v1/publisher';

let browserFetcherInstance: IFetcher | null = null;
let nodeFetcherInstancePromise: Promise<IFetcher> | null = null;

/**
 * Asynchronously gets the appropriate IFetcher instance.
 * For server-side rendering (SSR), it dynamically imports and creates the node-specific fetcher.
 * For client-side, it creates and returns the browser-specific fetcher.
 * @returns {Promise<IFetcher>} A promise that resolves to an IFetcher instance.
 */
export async function getInitializedMomentFetcher(): Promise<IFetcher> {
  if (import.meta.env.SSR) {
    if (!nodeFetcherInstancePromise) {
      nodeFetcherInstancePromise = import('@moment/net/common/node-fetcher.ts')
        .then((nodeFetcherModule) => {
          return nodeFetcherModule.createNodeMomentFetcher();
        })
        .catch((error) => {
          console.error('Failed to dynamically load or create node fetcher:', error);
          // Fallback strategy: Depending on requirements, you might throw,
          // or attempt to return a degraded-functionality fetcher.
          // For now, re-throwing to make the issue visible.
          throw new Error('Server-side IFetcher could not be initialized.');
        });
    }
    return nodeFetcherInstancePromise;
  } else {
    // For the browser, we can still create it synchronously if needed,
    // but to maintain a consistent async signature for this getter:
    if (!browserFetcherInstance) {
      browserFetcherInstance = createMomentFetcher();
    }
    return Promise.resolve(browserFetcherInstance);
  }
}
